import { IWidgetSelector } from 'core-components/sitebuilder/models/IWidgetSelector'
import { CompanySearch } from 'search/components/widgets/public/CompanySearch'

export const WidgetSelector = (props: IWidgetSelector) => {
  if (props.viewModel === 'company-search-lut-67150655') {
    return <CompanySearch {...props.props} />
  }
  if (props.viewModel === 'search-tool-tm-27606364') {
    return <CompanySearch {...props.props} />
  }
  return null
}
